<template>
  <div class="p-6">
    <div class="max-w-lg mx-auto">
      <div class="card">
        <div class="p-12">
          <h1 class="mb-6 text-2xl font-bold">
            Company Details
          </h1>
          <form @submit.prevent="submit">
            <fieldset class="w-full form-group">
              <label class="form-label" for="name">Company/Organisation Name</label>
              <input id="name" placeholder="Enter your company or organisation name" class="py-3 shadow-sm form-input" v-model="$parent.form.name" required autofocus tabindex="1">
              <validations field="name" :errors="errors" />
            </fieldset>
            <fieldset class="w-full form-group">
              <label class="form-label" for="country">Country</label>
              <select id="country" class="w-full py-3 form-select" v-model="$parent.form.country">
                <option value="" disabled>Select a country</option>
                <option v-for="country in countries" :key="country.id" :value="country.id">{{ country.name }}</option>
              </select>
              <validations field="country" :errors="errors" />
            </fieldset>
            <fieldset class="w-full form-group">
              <label class="form-label" for="timezone">Time Zone</label>
              <select id="timezone" class="w-full py-3 form-select" :disabled="!$parent.form.country" v-model="$parent.form.timezone">
                <option v-for="timezone in timezones" :key="timezone.name" :value="timezone.name">
                  {{ timezone.name }} (GMT{{ timezone.utcOffsetStr }})
                </option>
              </select>
              <validations field="timezone" :errors="errors" />
            </fieldset>
            <fieldset class="w-full form-group">
              <label class="form-label" for="currency">Currency</label>
              <select id="currency" class="w-full py-3 form-select" :disabled="!$parent.form.country" v-model="$parent.form.currency">
                <option v-for="currency in currencies" :key="currency.code" :value="currency.code">
                  {{ currency.currency }} ({{ currency.code }})
                </option>
              </select>
              <validations field="currency" :errors="errors" />
            </fieldset>
            <button type="submit" class="w-full mt-2 btn btn-lg btn-primary">
              Save Details
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ct from 'countries-and-timezones'
import cc from 'currency-codes'

export default {
  name: 'OnboardingCompany',

  computed: {
    countries () {
      let countries = []
      let unsorted = ct.getAllCountries()
      for (let key in unsorted) {
        countries.push(unsorted[key])
      }
      countries.sort((a, b) => {
        if (a.name < b.name) { return -1 }
          if (a.name > b.name) { return 1 }
            return 0
        })
      return countries
    }, 

    timezones () {
      if (this.selectedCountry) {
        return ct.getTimezonesForCountry(this.selectedCountry.id)
      } else {
        return []
      }
    },

    currencies () {
      if (this.selectedCountry) {
        return cc.country(this.selectedCountry.name.toLowerCase())
      }
    },

    selectedCountry () {
      return this.countries.find(ct => ct.id === this.$parent.form.country)
    }
  },

  data () {
    return {
      submitting: false,
      errors: []
    }
  },

  methods: {
    submit () {
      let array = []
      
      if (!this.$parent.form.name) {
        array.push({ 
          field: 'name', 
          rule: 'name_required', 
          message: `Your company or organisation name is required`
        })
      } 

      if (!this.$parent.form.country) {
        array.push({ 
          field: 'country', 
          rule: 'country_required', 
          message: `Please select the country where your company operates.`
        })
      } 

      if (!this.$parent.form.timezone) {
        array.push({ 
          field: 'timezone', 
          rule: 'timezone_required', 
          message: `Please select the timezone your company operates in.`
        })
      } 

      if (!this.$parent.form.currency) {
        array.push({ 
          field: 'currency', 
          rule: 'currency_required', 
          message: `Please select your preferred currency.`
        })
      } 

      this.errors = array

      if (!this.errors.length) {
        this.$router.push({ name: 'OnboardingBrand' })
      }
    }
  }
}
</script>